import { useEffect, useState } from "react";
// REDUX
import { useLazyGetBanksQuery } from "../../redux/banks/bankAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// UTILS
import {
  BankAddressRow,
  EventAddressStatus,
  eventAddressStatusOf,
} from "../../utils/mceIdl/eventAddressStatus";

const BANKS_PER_LOOKUP = 200;

/**
 * Whether the banks that run `adapterId` name an event reporting address, which MCE
 * faults need. Looked up once when `enabled` turns on; a lookup that fails leaves the
 * status unknown, and the editor's help text says the general thing instead.
 */
export default function useBankEventAddressStatus(
  adapterId: string | undefined,
  enabled: boolean,
): EventAddressStatus {
  const [status, setStatus] = useState<EventAddressStatus>({ state: "unknown" });
  const [triggerGetBanks] = useLazyGetBanksQuery();

  useEffect(() => {
    if (!enabled || !adapterId) {
      setStatus({ state: "unknown" });
      return undefined;
    }
    let current = true;
    (async () => {
      try {
        const token = await GETJwtToken();
        const answer = await triggerGetBanks({
          page: 1,
          limit: BANKS_PER_LOOKUP,
          token,
          searchAndFilterString: `&filter_target=adapter_id&filter=${adapterId}`,
        }).unwrap();
        const rows = Array.isArray(answer?.data) ? (answer.data as BankAddressRow[]) : [];
        if (current) setStatus(eventAddressStatusOf(rows, adapterId));
      } catch {
        if (current) setStatus({ state: "unknown" });
      }
    })();
    return () => {
      current = false;
    };
  }, [adapterId, enabled, triggerGetBanks]);

  return status;
}
